module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_SK-0d0441815665eb967f0779b9ca733d36.svg";